import { atom } from 'recoil';
import { setRecoil, getRecoil } from 'recoil-nexus';

export type ModalProps = {
  onRequestClose?(): void;
  // Any extra props to pass to modal
  extra?: any;
};

export type ModalState = {
  modalId: string;
  props?: ModalProps;
};

export const modalState = atom<ModalState | null>({
  key: 'modalState',
  default: null,
});

export const openModal = (modalId: string, props?: ModalProps) => {
  setRecoil(modalState, { modalId, props });
};

/** Open another player's public profile. Returns to the previous modal if one was open. */
export const openUserProfile = (
  userId: string | number | null | undefined,
) => {
  if (userId == null) {
    return;
  }

  const id = String(userId);
  if (!id || id === 'anon') {
    return;
  }

  const current = getRecoil(modalState);
  const returnTo =
    current?.modalId && current.modalId !== 'user-info'
      ? { modalId: current.modalId, props: current.props }
      : undefined;

  openModal('user-info', {
    extra: {
      userId: id,
      returnTo,
    },
  });
};

export const closeModal = (modalId?: string) => {
  const modal = getRecoil(modalState);

  if (!modalId) {
    setRecoil(modalState, null);
    return;
  }

  if (modalId === modal?.modalId) {
    setRecoil(modalState, null);
  }
};
